import $ from 'jquery';
import {getWidth} from "../utils/window";

export default function headerSection() {
	const $html = $('html');
	const $scroller = $('html, body');

	const $hamburger = $('.hamburger');
	const mainBodies = $('html, body, #content');

	if ($hamburger.length) {
		$hamburger.click(function (){
			if (getWidth() < 1080) {
				if ($hamburger.hasClass('is-active')) {
					mainBodies.css('overflow', 'hidden');
				} else {
					mainBodies.css('overflow', '');
				}
			}
		});
	}

	// const $header = $('#header');
	// const $headerNav = $('#header-nav');
	// const headerToggler = $headerNav.data('toggler');

	// if (headerToggler) {
		// headerToggler.on('toggle', function() {
		// 	$html.toggleClass('is-header-open', headerToggler.isOpen);
		//
		// 	if (headerToggler.isOpen) {
		// 		$scroller.animate({ scrollTop: 0 }, { duration: 200 });
		// 	}
		// });
	// }
}




// WEBPACK FOOTER //
// ./source/scripts/sections/header.js